function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black': 'rgb(17, 17, 17)','green-black': 'rgb(17, 17, 17)','navy': 'rgb(19, 34, 87)','night-blue': 'rgb(19, 34, 87)','blue': 'rgb(0, 0, 139)','aqua': 'rgb(0, 206, 209)','teal': 'rgb(57, 204, 204)','olive': 'rgb(128, 128, 0)','green': 'rgb(0, 100, 0)','lime': 'rgb(1, 255, 112)','yellow': 'rgb(255, 220, 0)','orange': 'rgb(255, 133, 27)','red': 'rgb(139, 0, 0)','fuchsia-f012be': '','purple': 'rgb(177, 13, 201)','maroon': 'rgb(133, 20, 75)','silver': 'rgb(221, 221, 221)','gray': 'rgb(170, 170, 170)','grey': 'rgb(170, 170, 170)','white': 'rgb(255, 255, 255)','pink': 'rgb(250, 190, 190)','brown': 'rgb(154, 99, 36)','mint': 'rgb(170, 255, 195)','lavender': 'rgb(230, 190, 255)','bronze': 'rgb(160, 82, 45)','copper': 'rgb(205, 133, 63)','zwart': 'rgb(17, 17, 17)','blauw': 'rgb(0, 0, 139)','groenblauw': 'rgb(0, 206, 209)','olijf': 'rgb(128, 128, 0)','groen': 'rgb(0, 100, 0)','forest': 'rgb(0, 100, 0)','limoen': 'rgb(1, 255, 112)','geel': 'rgb(255, 220, 0)','oranje': 'rgb(255, 133, 27)','rood': 'rgb(139, 0, 0)','paars': 'rgb(177, 13, 201)','kastanjebruin': 'rgb(133, 20, 75)','zilver': 'rgb(221, 221, 221)','grijs': 'rgb(170, 170, 170)','wit': 'rgb(255, 255, 255)','roze': 'rgb(250, 190, 190)','bruin': 'rgb(154, 99, 36)','lavendel': 'rgb(230, 190, 255)','brons': 'rgb(160, 82, 45)','koper': 'rgb(205, 133, 63)','terra': 'rgb(227, 115, 94)','lightgrey': 'rgb(211, 211, 211)','lichtgrijs': 'rgb(211, 211, 211)','lightgreen': 'rgb(144, 238, 144)','lichtgroen': 'rgb(144, 238, 144)','creme': 'rgb(255, 255, 224)','creme': 'rgb(255, 255, 224)','donkerrood': 'rgb(139, 0, 0)','raspberry-red': 'rgb(139, 0, 0)','darkred': 'rgb(139, 0, 0)','grasgroen': 'rgb(0, 100, 0)','lawngreen': 'rgb(0, 100, 0)','sand': 'rgb(255, 255, 224)','opale': 'rgb(176, 224, 230)','azure': 'rgb(65, 105, 225)','lightblue': 'rgb(173, 216, 230)','lichtblauw': 'rgb(173, 216, 230)','zalm': 'rgb(255, 160, 122)','salmon': 'rgb(255, 160, 122)','seagrass': 'rgb(145, 152, 139)','crushedberry': 'rgb(129, 85, 96)','smokedoak': 'rgb(148, 121, 93)','saffron': 'rgb(174, 139, 72)','clay': 'rgb(156, 86, 66)','goud': 'rgb(255, 215, 0)','donker-groen': 'rgb(45, 87, 44)','donker-rood': 'rgb(139, 0, 0)','donkerblauw': 'rgb(10, 52, 99)','gras-groen': 'rgb(124, 252, 0)','licht-blauw': 'rgb(173, 216, 230)','licht-groen': 'rgb(173, 205, 180)','zand': 'rgb(231, 208, 169)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor','kleur',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
